import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppMaterialModule } from '@app/app-material.module';
import { AnimationsModule } from '@shared/animations/animations.module';
import { ComponentsModule } from '@shared/components/components.module';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { DetalhesNotificacaoComponent } from './components/detalhes-notificacao/detalhes-servico-executado.component';
import { NotificacaoController } from './controllers';
import { NotificacoesComponent } from './pages/notificacoes/notificacoes.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [NotificacoesComponent, DetalhesNotificacaoComponent],
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppMaterialModule,
    ComponentsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    AnimationsModule,
  ],
  providers: [provideNgxMask(maskConfig), NotificacaoController],
})
export class NotificacaoModule {}
